import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cloud-cover-container my-2 py-1" }
const _hoisted_2 = { class: "cloud-cover-icon" }
const _hoisted_3 = { class: "cloud-cover-label" }
const _hoisted_4 = { class: "cloud-cover-label-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, { size: "35" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.cloudIcon), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "cloud-cover-label-text" }, [
        _createTextVNode(" Median historical"),
        _createElementVNode("br"),
        _createTextVNode("cloud cover: ")
      ], -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.cloudCoverFracToLabel), 1)
    ])
  ]))
}